export default __webpack_public_path__ + "801ae3d0ed7c24672d6dfddd92139ff9.png";